var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["scroll-bar-" + this.axis,_vm.down?"ismove":""],style:(_vm.barStyle),on:{"mousedown":this.downHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }